(ns dashboard.components.questionnaire.section-tabs
  (:require [re-frame.core :as rf]
            ["react" :as react]
            [dashboard.html :as html]
            [dashboard.services.section :as section-services]))

(defn Section [{:keys [id name] :as section} current-section-id questionnaire-id section-reorder-enabled dragged-section set-dragged-section on-tab-selected]
  (let [[show-drop set-show-drop] (react/useState false)]
    [:li {:key id
          :class (when (= current-section-id id)
                   "is-secondary")
          ;; Section dragging
          :draggable section-reorder-enabled
          :on-drag-start (fn [_]
                           (set-dragged-section section))
          :on-drag-enter (fn [e]
                           (when (and section-reorder-enabled
                                      dragged-section
                                      (not= section dragged-section))
                             (.preventDefault e)
                             (set-show-drop true)))
          :on-drag-leave (fn [e]
                           (when section-reorder-enabled
                             (.preventDefault e)
                             (set-show-drop false)))
          :on-drag-over (fn [e]
                          (when (and section-reorder-enabled
                                     dragged-section
                                     (not= section dragged-section))
                            (.preventDefault e)))
          :on-drag-end (fn [_]
                         (when section-reorder-enabled
                           (set-dragged-section nil)))
          :on-drop (fn [e]
                     (when section-reorder-enabled
                       (.preventDefault e)
                       (set-show-drop false)
                       (set-dragged-section nil)
                       (rf/dispatch [::section-services/move-section questionnaire-id dragged-section (:ordinal section)])))
          :style {:border (when show-drop
                            "0.2em dotted")}}
     [:a {:on-click #(when-not section-reorder-enabled
                       (on-tab-selected section))
          :title "Click to add the section to active filters"}
      (html/as-hiccup-with-anchors name)]]))

(defn section-tabs [{:keys [questionnaire-id current-section-id sections loading on-tab-selected]}]
  (let [[section-reorder-enabled set-section-reorder-enabled] (react/useState false)
        [dragged-section set-dragged-section] (react/useState nil)]
    [:div {:style {:display "flex"
                   :align-items "center"}}
     [:div.tabs.is-toggle.mb-0>ul
      (map (fn [{:keys [id] :as section}]
             ^{:key id}
             [:f> Section section current-section-id questionnaire-id section-reorder-enabled dragged-section set-dragged-section on-tab-selected])
           sections)
      (when loading
        [:li {:class (when (= 0 (count sections)) "pb-2")}
         [:div.mx-2.loader]])]
     [:a.button.is-small.is-rounded.ml-2
      {:on-click #(set-section-reorder-enabled (not section-reorder-enabled))
       :class (if section-reorder-enabled "is-primary" "is-outlined")
       :title (if section-reorder-enabled
                "Click to deactivate section reordering mode"
                (str "Click to activate section reordering mode\n\n"
                     "Reorder sections by dragging, and dropping the section onto the place where it should be moved to.\n\n"
                     "Sections between the start and end of move will re-arranged accordingly."))}
      [:span.mr-1 "Reorder sections"]
      [:span.icon>i.fas.fa-sort]]]))
